// extracted by mini-css-extract-plugin
export var divider = "_yg-0";